





























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
class PageCollectionCodeTrackingRequest extends PageRequest {
  id: number;
}
@Component
export default class ViewCollectionCode extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) mainSerialNo: string;

  namespace = "collectionCodeTracking";
  collectionCode: any = null;
  pagerequest: PageCollectionCodeTrackingRequest = new PageCollectionCodeTrackingRequest();
  spinShow: boolean = false;
  code: string = "";
  id: number = 0;
  get store() {
    return this.$store.state.collectionCodeTracking;
  }
  cancel() {
    (this.$refs.viewCollectionCodeForm as any).resetFields();
    this.$emit("input", false);
  }
  get list() {
    var re = this.$store.state.collectionCodeTracking.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  preGetPage() {
    this.pagerequest.id = this.id;
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.spinShow = true;
      this.$store
        .dispatch({
          type: `collectionCodeProduct/getInfo`,
          data: { code: this.mainSerialNo },
        })
        .then((result) => {
          this.collectionCode = result;
          this.id = this.collectionCode.id;
          this.searchData();
        })
        .finally(() => {
          this.spinShow = false;
        });
    }
  }
  async created() {}

  get columns() {
    return [
      {
        title: Util.L("Order"),
        width: 50,
        key: "orderNo",
      },
      {
        title: Util.L("Type"),
        key: "actionTypeName",
        width: 150,
      },
      {
        title: Util.L("Content"),
        key: "content",
        width: 300,
      },
      {
        title: "Mã phiếu",
        width: 150,
        render: (h: any, params: any) => {
          return h("span",  params.row.refCode == null ? "" : params.row.refCode);
        },
      },
      {
        title: "Mã SO | PO",
        width: 150,
        render: (h: any, params: any) => {
          return h("span",  params.row.poOrSOCode == null ? "" : params.row.poOrSOCode);
        },
      },
      {
        title: "Mã DH | RO",
        width: 150,
        render: (h: any, params: any) => {
          return h("span",  params.row.sorOrROCode == null ? "" : params.row.sorOrROCode);
        },
      },
      {
        title: "Người thực hiện",
        width: 150,
        render: (h: any, params: any) => {
          return h("span",  `${params.row.userName} - ${params.row.userFullName}`);
        },
      },
    ];
  }
}
